"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let VdBatchAddModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.errors = new Array();
    this.id = "";
    this.old_name = "";
  }
};
VdBatchAddModel.model = "vd.batch.edit";
VdBatchAddModel = __decorateClass([
  Annotation.ModelMeta
], VdBatchAddModel);
export let ShopBatchAddModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.account = "";
    this.password = "";
    this.platform = "";
    this.ip = "";
    this.errors = new Array();
    this.shop_url = "";
    this.vd_name = "";
  }
};
ShopBatchAddModel.model = "shop.batch.edit";
ShopBatchAddModel = __decorateClass([
  Annotation.ModelMeta
], ShopBatchAddModel);
export let ShopBatchEditModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.name = "";
    this.account = "";
    this.password = "";
    this.platform = "";
    this.ip = "";
    this.errors = new Array();
    this.shop_url = "";
    this.vd_name = "";
  }
};
ShopBatchEditModel.model = "shop.batch.edit";
ShopBatchEditModel = __decorateClass([
  Annotation.ModelMeta
], ShopBatchEditModel);
export let UpdateErrorModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.code = "";
    this.message = "";
  }
};
UpdateErrorModel.model = "error";
UpdateErrorModel = __decorateClass([
  Annotation.ModelMeta
], UpdateErrorModel);
